import {ProjectData} from '../content/projectdata'

export const manageProjects = (state=[], action) => {
  switch (action.type) {
    case 'FILTER_PROJECTS':
      if (action.payload === 'all') {
        return ProjectData;
      } else {
        return ProjectData.filter((proj)=>{
          return proj.category === action.payload;
        })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/manageProjects.js